import React from "react";
import StandardSignPostCard from "../StandardSignPostCard";

export const SuccessStoryCard: React.FC<DogsTrust.SignPostCardProps> = ({
	...props
}) => {
	return <StandardSignPostCard {...props} isSuccessStory={true} />;
};

export default SuccessStoryCard;
